import Bind from 'bind.js';
import Form from './Form.js';

export default class ThreeColumns {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.addTemplate();
    this.addColumns();
  }

  addTemplate() {
    let template = `
      <div class="three-columns span12">
        <div class="column1 span3">
        </div>
        <div class="column2 span4">
        </div>
        <div class="column3 span5">
        </div>
      </div>
    `
    this.parentElement.insertAdjacentHTML("afterbegin", template);
  }

  addColumns() {
    this.editor = Bind(
      {
        column1: this.data.get('column1').toJS(),
        column2: this.data.get('column2').toJS(),
        column3: this.data.get('column3').toJS()
      },
      {
        column1: {
          dom: '.column1',
          transform: function(columnData, bindObj) {
            return (columnData.title) ? renderColumnData(bindObj.column1, columnData)
                                      : generateContent(columnData);
          }
        },
        column2: {
          dom: '.column2',
          transform: function(columnData, bindObj) {
            return (columnData.title) ? renderColumnData(bindObj.column2, columnData)
                                      : generateContent(columnData);
          }
        },
        column3: {
          dom: '.column3',
          callback: function() {
            this.column3.formElement.registerCallback();
          },
          transform: function(columnData, bindObj) {
            return (columnData.title) ? renderColumnData(bindObj.column3, columnData)
                                      : generateContent(columnData);
          }
        }
      }
    )
  }

  reRender(data) {
    this.data = data;
    this.editor.url = data.get('url');
  }
}

const renderColumnData = (column, columnData) => {
  let columnContent = document.createElement('div');
  for (let key in columnData.content) {
    if (columnData.content.hasOwnProperty(key)) {
      let newContent = document.createElement('div');
      newContent.innerHTML = columnData.content[key];
      newContent.className = key + " content";

      columnContent.appendChild(newContent);
    }
  }

  if (columnData.form) {
    column.formElement = new Form(columnData.form);
    columnContent.appendChild(column.formElement.getTemplate());
  }

  return `
    <div class="title">${columnData.title}</div>
    ${columnContent.innerHTML}
  `;
}

const generateContent = (columnData) => {
  let columnContent = document.createElement('div');
  for (let key in columnData.content) {
    if (columnData.content.hasOwnProperty(key)) {
      let newTitle = document.createElement('div');
      newTitle.className = "title";
      newTitle.innerHTML = key.capitalizeFirstLetter();

      let newContent = document.createElement('div');
      newContent.innerHTML = columnData.content[key];
      newContent.className = key + " content content-margin";

      columnContent.appendChild(newTitle);
      columnContent.appendChild(newContent);
    }
  }

  return `
    ${columnContent.innerHTML}
  `;
}

String.prototype.capitalizeFirstLetter = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}



// WEBPACK FOOTER //
// ./src/renderers/ThreeColumns.js